
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    paymentMethod: {
      default: '',
      type: String
    },
  },
});
